/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../constant"
import VALIDATE_CONSTANT from "../../constant/validateConstant"
import SikutyosonService from "../../service/master/sikutyoson/sikutyosonService"
import {
  TSikutyosonListGetReq,
  T市区町村,
} from "../../service/master/sikutyoson/TSikutyoson"

import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import Spinner from "../Spinner"

/**
 * 市区町村検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const SikutyosonSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    dantaiCode?: string
    todohuken?: string
    sikutyoson?: string
    is市区町村のみ?: boolean
    setData: (value: T市区町村) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [都道府県名, set都道府県名] = useState<string>()
  const [市区町村名, set市区町村名] = useState<string>()

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  // PropsValues設定管理フラグ
  const [isApplyPropsValues, setIsApplyPropsValues] = useState(false)

  // 初期化完了フラグ
  const [isAllComponentInitialized, setIsAllComponentInitialized] =
    useState<boolean>(false)

  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async (searchCondition?: {
    都道府県名漢字?: string
    市区町村名?: string
  }) => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)

    let currentSearchCondition: TSikutyosonListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = {
        都道府県名漢字: 都道府県名 ?? undefined,
        市区町村名漢字: 市区町村名,
      }
    }
    try {
      const res = await new SikutyosonService().getList({
        ...currentSearchCondition,
        市区町村のみフラグ: props.is市区町村のみ ?? false,
      })
      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: T市区町村) => {
    props.setData(item)
    props.setIsShow(false)
  }

  /**
   * PropsValues適用処理
   */
  const applyPropsValues = async () => {
    set都道府県名(props.todohuken ?? "")
    set市区町村名(props.sikutyoson ?? "")

    // IsApplyPropsValues ON
    setIsApplyPropsValues(true)
  }

  /**
   * 入力初期化
   */
  const clearInput = () => {
    set都道府県名("")
    set市区町村名("")

    const newData = {
      data: createCollectionView([], pageSize),
    }
    if (flexGrid != null) {
      flexGrid.itemsSource = newData.data
      flexGrid.refresh()
    }
    setGridData(newData)
  }

  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {}, [])

  // 全コンポーネント初期化監視
  useEffect(() => {
    if (!flexGrid) {
      setIsAllComponentInitialized(false)
      return
    }

    setIsAllComponentInitialized(true)
  }, [isAllComponentInitialized, flexGrid])

  // モーダル表示・非表示変更時処理
  useEffect(() => {
    // 全コンポーネントの初期化が完了していない場合は待機
    if (!isAllComponentInitialized) return

    // 表示
    if (props.isShow) {
      // プロパティの適用が終わってない場合は適用
      if (!isApplyPropsValues) {
        // 1手遅らす
        setTimeout(() => {
          applyPropsValues()
        })
      } else {
        // 都道府県が設定されている場合は検索する
        if (props.todohuken != null && props.todohuken !== "") {
          search()
        }

        // スピナー解除
        setIsSpinnerShow(false)
      }
    } else {
      // 非表示時

      // PropsValuesの適用解除（クリアとして利用）
      if (isApplyPropsValues) {
        // スピナー表示
        setIsSpinnerShow(true)

        // アラートの解除
        setAlertSource(undefined)

        // 値クリア
        clearInput()

        // IsApplyPropsValues OFF
        setIsApplyPropsValues(false)
      }
    }
  }, [props.isShow, isApplyPropsValues, isAllComponentInitialized])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "市区町村検索"}
      setIsShow={props.setIsShow}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <ul className="list-cmn">
                <li className="list-cmn d-flex">
                  <div className="ms-2">
                    <TextInput
                      autoFocus={true}
                      id="都道府県"
                      name="都道府県"
                      value={都道府県名}
                      setValue={set都道府県名}
                      maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                      placeholder="都道府県"
                    />
                  </div>
                  <div className="ms-2">
                    <TextInput
                      id="市区町村"
                      name="市区町村"
                      value={市区町村名}
                      setValue={set市区町村名}
                      maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                      placeholder="市区町村"
                    />
                  </div>
                  <Button
                    className="ms-2"
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault()
                      search()
                    }}>
                    <FontAwesomeIcon icon={faSearch} />
                    検索
                  </Button>
                </li>
                <li className="list-cmn  d-flex"></li>
              </ul>
            </Col>
          </Row>
          <Row>
            <Col className="text-end mb-2"></Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "30rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                width={CONSTANT.GRID.COL_SIZE.COL_CODE_SIZE}
                header="選択"
                align={"center"}
                binding="市区町村ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(context: TWijmoCellTemplateContext<T市区町村>) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={CONSTANT.GRID.COL_SIZE.COL_CODE_SIZE}
                header="都道府県"
                binding="都道府県名漢字"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={CONSTANT.GRID.COL_SIZE.COL_CODE_SIZE}
                header="市区町村"
                binding="市区町村名漢字"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default SikutyosonSearchModal
